import { Col, Row } from 'react-bootstrap'
import { CHECKLIST } from '../../constants'
import RegistrySideNavContainer from '../../components/registry-sidenav'
import RegistryChecklistApp from './RegistryChecklistApp'

export function ChecklistContainer() {
  return (
    <div className="container mts mtl-sm pbxl" id="registry">
      <Row>
        <Col className="hidden-xs" sm={3}>
          <RegistrySideNavContainer activeNav={CHECKLIST} />
        </Col>
        <Col sm={8} xs={12}>
          <RegistryChecklistApp />
        </Col>
      </Row>
    </div>
  )
}
